export const MAINNET_CONTRACTS = {
  app: "0x1eFA8F82d9E919F6b6A5f1701131c9Cb1a943BAA",
  defaultToken: "0x93198F5e56443286b50Cf749dFb6A27f251aA630", // RYF on lens mainnet
  taskEscrowPool: "0xE476d902EA87AfCb5C1CF646751ad5306f16B271", // Placeholder, replace with actual address
  bscPool: "0xa615739b4D9CBcE3AC0c8F453E25B92B037a7162",
  lensMinter: "0x58966497B86FD5094662B42a075240F86AB42d99"
} as const;

export const TESTNET_CONTRACTS = {
  app: "0xb3855583511c5f02168a8784B8125D72BD97caB7",
  defaultToken: "0x7326D8584c6b891B2f4B194CDF5ba746dD0D4080", // tRYF on lens testnet
  taskEscrowPool: "0x95207816564EB34b13De560a4F572b45e3001bc2",
  bscPool: "0xeD96615ceC4fB02CE9D74B9161Ef0F935800D8e3",
  lensMinter: "0x833eDAD796b30FEBb72534D53Cc97bB8C9b33B12"
} as const;